import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface SessionState {
  user: {
    givenName: string;
    surName: string;
    jobTitle: string;
    email: string;
  };
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'session' })
export class SessionStore extends Store<SessionState> {
  constructor() {
    super({
      user: {
        givenName: '',
        surName: '',
        jobTitle: '',
        email: '',
      },
    });
  }
}
